import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, ModuleFE_WindowMessenger, Button, TS_Input } from '@nu-art/thunderstorm-frontend/index';
class PgDev_WindowMessenger_Class extends ComponentSync {
    constructor() {
        super({});
        ModuleFE_WindowMessenger
            .createReceiver(window.origin)
            .addProcessor('test', (message) => {
            console.log('Got message with key test:', message.payload);
            this.setState({ key: message.key, data: message.payload });
        })
            .addProcessor('test2', (message) => {
            console.log('Got message with key test2:', message.payload);
        })
            .mount();
    }
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { id: 'pg-dev__window-messenger', children: [_jsxs(LL_V_L, { children: [_jsxs(LL_H_C, { style: { gap: '8px' }, children: [_jsx("div", { children: "Key:" }), _jsx("div", { children: this.state.key })] }), _jsxs(LL_H_C, { style: { gap: '8px' }, children: [_jsx("div", { children: "Data:" }), _jsx("div", { children: JSON.stringify(this.state.data) })] })] }), _jsx("iframe", { src: 'https://localhost:8100/app-tools/0aa96164cf873d175287c8300e3ad58c', style: { width: '100%' } })] });
    }
}
class FrameRenderer extends ComponentSync {
    messenger = ModuleFE_WindowMessenger.createMessenger(window.parent);
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { children: [_jsx(TS_Input, { type: 'text', value: this.state.value, onChange: value => this.setState({ value }) }), _jsx(Button, { onClick: e => {
                        this.messenger.sendMessage({ key: 'test', payload: this.state.value });
                    }, children: "Send" }), _jsx(Button, { onClick: e => {
                        this.messenger.sendMessage({ key: 'test2', payload: 123 });
                    }, children: "Send2" })] });
    }
}
export const PgDev_WindowMessenger = {
    name: 'window messenger',
    key: 'window-messenger',
    renderer: PgDev_WindowMessenger_Class
};
export const PgDev_WindowMessengerFrame = {
    name: 'window-messenger-frame',
    key: 'window-messenger-frame',
    renderer: FrameRenderer
};
